module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Bold.ttf
// module id = 76
// module chunks = 8